import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRightIcon } from 'lucide-react';
import { newsItems } from '../../data/news';
export function News() {
  return <section aria-labelledby="news-title" className="py-20 lg:py-28" data-id="element-124" data-mp="1dbzjmbsqlk1x">
      <div className="mx-auto max-w-site px-6 lg:px-10" data-id="element-125" data-mp="1dbps2js1n4u4">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-126" data-mp="1iaaqqerndggg">
          <h2 id="news-title" className="font-serif text-4xl leading-tight tracking-tight text-ink lg:text-5xl" data-id="element-127" data-mp="14arw8orre3mm">
            Actualités et analyses
          </h2>
          <Link to="/actualites" className="inline-flex items-center gap-2 self-start border-b border-ink pb-1 text-[15px] text-ink transition-colors duration-150 hover:border-accent hover:text-accent md:self-auto" data-id="element-128" data-mp="18ajwme7013gw">
            Toutes les actualités
            <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-129" data-mp="2orxuml7h6g5s" />
          </Link>
        </div>

        <ul className="mt-12 grid border-t border-ink md:grid-cols-3" data-id="element-130" data-mp="2tpg6ajcvn9hh">
          {newsItems.map(item => <li key={item.title} className="border-b border-line md:border-b-0 md:border-r md:last:border-r-0" data-id="element-131" data-mp="2uk8sfm202d9l">
              <Link to="/actualites" className="group flex h-full flex-col py-8 md:px-8 md:first:pl-0" data-id="element-132" data-mp="33evt64wpy1fi">
                <p className="text-sm text-muted" data-id="element-133" data-mp="2zelgyaic2es7">
                  <span className="text-accent" data-id="element-134" data-mp="2bnfz5psu1cf9">{item.category}</span> · <time data-id="element-135" data-mp="2bo972u3j27yz">{item.date}</time>
                </p>
                <h3 className="mt-4 font-serif text-xl leading-snug text-ink transition-colors duration-150 group-hover:text-accent" data-id="element-136" data-mp="26p65xkqo4lwa">
                  {item.title}
                </h3>
                <span className="mt-auto inline-flex items-center gap-2 pt-6 text-sm text-ink-soft" data-id="element-137" data-mp="2fpko4b8c5kvk">
                  Lire
                  <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-138" data-mp="3w2jb1c6ludyg" />
                </span>
              </Link>
            </li>)}
        </ul>
      </div>
    </section>;
}